/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Tail_ExtremeInputs */

const en_us2_body_assessment_warning_tail_extreme = /** @type {(inputs: Body_Assessment_Warning_Tail_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very lean, very heavy or very muscular bodies are further from what the equation was fitted on: the estimate is less reliable and the range was widened.`)
};

const pt_br2_body_assessment_warning_tail_extreme = /** @type {(inputs: Body_Assessment_Warning_Tail_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpos muito magros, muito pesados ou muito musculosos estão mais longe do que a equação foi ajustada: a estimativa é menos confiável e a faixa foi ampliada.`)
};

const es_419_body_assessment_warning_tail_extreme = /** @type {(inputs: Body_Assessment_Warning_Tail_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los cuerpos muy delgados, muy pesados o muy musculosos están más lejos de aquello con lo que se ajustó la ecuación: la estimación es menos confiable y el rango se amplió.`)
};

const pt_pt2_body_assessment_warning_tail_extreme = /** @type {(inputs: Body_Assessment_Warning_Tail_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpos muito magros, muito pesados ou muito musculados estão mais longe daquilo para que a equação foi ajustada: a estimativa é menos fiável e o intervalo foi alargado.`)
};

const fr_fr2_body_assessment_warning_tail_extreme = /** @type {(inputs: Body_Assessment_Warning_Tail_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les corps très minces, très lourds ou très musclés s'éloignent de ceux sur lesquels l'équation a été ajustée : l'estimation est moins fiable et la fourchette a été élargie.`)
};

const de_de2_body_assessment_warning_tail_extreme = /** @type {(inputs: Body_Assessment_Warning_Tail_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr schlanke, sehr schwere oder sehr muskulöse Körper liegen weiter weg von dem, woran die Gleichung angepasst wurde: Die Schätzung ist weniger verlässlich und die Spanne wurde erweitert.`)
};

const it_it2_body_assessment_warning_tail_extreme = /** @type {(inputs: Body_Assessment_Warning_Tail_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpi molto magri, molto pesanti o molto muscolosi sono più lontani da quelli su cui è stata tarata l'equazione: la stima è meno affidabile e l'intervallo è stato ampliato.`)
};

/**
* | output |
* | --- |
* | "Very lean, very heavy or very muscular bodies are further from what the equation was fitted on: the estimate is less reliable and the range was widened." |
*
* @param {Body_Assessment_Warning_Tail_ExtremeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_tail_extreme = /** @type {((inputs?: Body_Assessment_Warning_Tail_ExtremeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Tail_ExtremeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_tail_extreme(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_tail_extreme(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_tail_extreme(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_tail_extreme(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_tail_extreme(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_tail_extreme(inputs)
	return en_us2_body_assessment_warning_tail_extreme(inputs)
});
export { body_assessment_warning_tail_extreme as "body-assessment.warning.tail_extreme" }